import { GenericFilter } from '@/components/GenericFilter';
import type { ListCampaignFilterType, ListCampaignFilterTypeWithValues } from '@shelflix/schemas/campaign/list';
import { DatePicker } from '@shelflix/ui-web/components/DatePicker/index';
import { DateRange } from 'react-day-picker';

interface CompaignFilterProps {
  onChange: (filters: ListCampaignFilterTypeWithValues) => void;
  period: DateRange;
  onChangePeriod: (period: DateRange) => void;
}

export function CampaignFilter({ onChange, period, onChangePeriod }: CompaignFilterProps) {
  const options: ListCampaignFilterType = {
    search: {
      label: 'Nome da campanha',
      fields: ['name'],
      order: 0,
    },
    filter: [
      {
        label: 'Status',
        field: { name: 'status', condition: 'equals' },
        order: 2,
        items: [
          { text: 'Ativo', value: 'ACTIVE' },
          { text: 'Offline', value: 'OFFLINE' },
          { text: 'Warn', value: 'WARN' },
        ],
      },
    ],
    sort: {
      label: 'Ordenar por',
      order: 3,
      options: [
        { field: 'createdAt', direction: 'asc', text: 'Mais antigo' },
        { field: 'createdAt', direction: 'desc', text: 'Mais recente' },
      ],
    },
  };

  const customComponents = [
    <div className="flex flex-1 flex-col justify-end gap-1" key="period" style={{ order: 1 }}>
      <span className="text-xs font-medium">Período</span>
      <DatePicker
        mode="range"
        onChange={(value) => onChangePeriod(value as DateRange)}
        placeholder="Selecionar data"
        className="w-full"
        value={period}
      />
    </div>,
  ];

  return <GenericFilter customComponents={customComponents} options={options} onChange={onChange} />;
}
